import { CSSProperties } from "react";

import { useProjectedChart, useTheme } from "@hooks";
import { constants, spacing } from "@layout";

export const useStyles = () => {
  const { invertedTheme } = useProjectedChart();

  const { theme } = useTheme();

  const chartTheme = theme.chart.projection;

  const styles: Record<string, CSSProperties> = {
    container: {
      backgroundColor: invertedTheme ? chartTheme.inverted.footer : chartTheme.default.footer,
      padding: spacing.xs,
      borderRadius: constants.radius.button,
      marginTop: spacing.xs,
    },
    text: {
      color: invertedTheme ? chartTheme.inverted.text : chartTheme.default.text,
    },
  };

  return styles;
};
